import { Typography } from 'antd'
import {
    getMaterialDisplayValue,
    getDisplayValue,
} from '@Orders/OrderDetailsPage/Status/logic'

import Box from '~/core/Box'
import Text from '~/core/Text'
import {
    PartAttributesType,
    ProcessType,
} from '~/apps/consumer/components/PartViewerModal/types'
import {
    usePostProcessesInfo,
    BLACK_ALPHA_BOTTOM,
    HEADER_STYLES,
    transformAttributeDetails,
    getPrimaryProcessMaterialDetails,
} from '~/apps/consumer/components/PartViewerModal/logic'
import getColor from '~/lib/getColor'

export default function PartAttributes(props: PartAttributesType) {
    const {
        quantity,
        processName,
        materialName,
        processes,
        material,
        isImOrder,
    } = props

    const postProcessesToDisplay = usePostProcessesInfo(processName, processes)

    const displayPostProcess = (
        process: Partial<ProcessType> | null,
        index: number,
    ) => {
        const name = process && process.processName
        let processNotes = process && process?.processNotes

        // This removes the custom admin notes from advanced inspection report
        // We should replace this with separate fields in a follow-up.
        if (
            process?.processName === 'Advanced Inspection Report' &&
            processNotes
        ) {
            const split = 'parts.'

            processNotes = processNotes.split(split)[0] + split
        }
        return (
            <Box direction="row" key={index} maxWidth="350px">
                <Typography.Paragraph
                    ellipsis={{ rows: 2 }}
                    style={{
                        marginBottom: isImOrder ? '0px' : '4px',
                        marginTop: isImOrder ? '0px' : '4px',
                        wordBreak: 'break-word',
                        color: isImOrder
                            ? getColor('blackAlpha85')
                            : getColor('blackAlpha65'),
                    }}
                >
                    {`${name} `}
                    {
                        <span>
                            {process && transformAttributeDetails(process)}
                        </span>
                    }
                    {processNotes && `(${processNotes})`}
                </Typography.Paragraph>
            </Box>
        )
    }

    const displayPostProcesses = () => {
        return (
            <Box direction="col">
                {postProcessesToDisplay.map((process, idx) =>
                    displayPostProcess(process as ProcessType, idx),
                )}
            </Box>
        )
    }

    const displayPrimaryProcessDetails = () => {
        const primaryProcessMaterialDetails = getPrimaryProcessMaterialDetails(
            processes,
            material,
            materialName,
        )

        return <Box>{primaryProcessMaterialDetails}</Box>
    }

    const imOrderDetailsDisplay = () => {
        const {
            materialGrade = null,
            color = null,
            colorCode = null,
        } = material || {}
        const finish = processes?.[0]?.finish || null
        const finishCode = processes?.[0]?.surfaceFinishCode || null

        return (
            <Box fontSize="14px" color="blackAlpha85" direction="col">
                <Box>{processName}</Box>
                {materialName && (
                    <Box>
                        {getMaterialDisplayValue(materialName, materialGrade)}
                    </Box>
                )}
                {color && (
                    <Box>
                        Color (
                        {getDisplayValue({
                            attribute: color,
                            attributeCode: colorCode,
                        })}
                        )
                    </Box>
                )}
                {finish && (
                    <Box>
                        Finish (
                        {getDisplayValue({
                            attribute: finish,
                            attributeCode: finishCode,
                        })}
                        )
                    </Box>
                )}
                <Box direction="col">
                    {postProcessesToDisplay.map((process, idx) =>
                        displayPostProcess(process as ProcessType, idx),
                    )}
                </Box>
            </Box>
        )
    }

    return (
        <Box
            direction="col"
            padding="8px 0 16px"
            borderBottom={BLACK_ALPHA_BOTTOM}
        >
            <Text style={HEADER_STYLES}>Configuration</Text>
            <Box direction="col">
                <Box
                    direction="col"
                    justifyContent="between"
                    marginBottom="0px"
                >
                    {isImOrder ? (
                        imOrderDetailsDisplay()
                    ) : (
                        <Box>
                            <Text fontSize="14px" color="blackAlpha85">
                                {displayPrimaryProcessDetails()}
                            </Text>
                        </Box>
                    )}
                    <Box margin={isImOrder ? 'auto 0' : '0'}>
                        <Text fontSize="14px" color="blackAlpha85">
                            Quantity {quantity}
                        </Text>
                    </Box>
                </Box>
                {!isImOrder && displayPostProcesses()}
            </Box>
        </Box>
    )
}
